export default __webpack_public_path__ + "static/media/vintage100-3.23b008d1.jpg";